import { render, staticRenderFns } from "./QueryShrimp.vue?vue&type=template&id=6ff5eab6&scoped=true&"
import script from "./QueryShrimp.vue?vue&type=script&lang=js&"
export * from "./QueryShrimp.vue?vue&type=script&lang=js&"
import style0 from "./QueryShrimp.vue?vue&type=style&index=0&id=6ff5eab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5eab6",
  null
  
)

export default component.exports